// frontend/src/components/DataTransformControls.js
import React from 'react';
import { Radio, Space } from 'antd';

// 1. 함수의 인자(props) 목록에 size를 추가합니다.
//    size 값이 없을 때를 대비해 기본값을 'middle'로 설정합니다.
const DataTransformControls = ({
    dataType,
    periodType,
    onDataTypeChange,
    onPeriodTypeChange,
    size = 'middle',
}) => {
    return (
        <Space>
            <Radio.Group
                value={dataType}
                onChange={(e) => onDataTypeChange(e.target.value)}
                optionType="button"
                buttonStyle="solid"
                size={size} // 2. 전달받은 size 값을 첫 번째 Radio.Group에 적용합니다.
            >
                <Radio.Button value="Value">값</Radio.Button>
                <Radio.Button value="Growth">성장률</Radio.Button>
            </Radio.Group>
            <Radio.Group
                value={periodType}
                onChange={(e) => onPeriodTypeChange(e.target.value)}
                optionType="button"
                buttonStyle="solid"
                size={size} // 3. 전달받은 size 값을 두 번째 Radio.Group에도 적용합니다.
            >
                <Radio.Button value="Monthly">월별</Radio.Button>
                <Radio.Button value="TTM">TTM</Radio.Button>
            </Radio.Group>
        </Space>
    );
};

export default DataTransformControls;